enum ActionType {
    REQUEST_AUDIT_LOG = '[AUDIT LOG] REQUEST AUDIT LOG',
    RECEIVED_AUDIT_LOG = '[AUDIT LOG] RECEIVE AUDIT LOG',
    LOG_PAGE_ACCESS = '[AUDIT LOG] LOG PAGE ACCESS',
}

export default ActionType
